import styled from 'styled-components'

import { Form, FormItemProps } from 'antd'
import { twMerge } from 'tailwind-merge'

// Instead of only hiding the colon (like ant design does), we remove it from the DOM
const NoColonFormItem = styled(Form.Item)`
    *::after {
        display: none;
    }
`

interface Props extends FormItemProps {
    label?: string | React.ReactNode
}

const FormItem = (props: Props) => {
    const { className, label, extra, children, ...rest } = props

    return (
        <NoColonFormItem
            {...rest}
            className={twMerge('mb-0', className)}
            label={
                label ? (
                    <>
                        {typeof label === 'string' ? (
                            <span title={label} className="overflow-hidden text-ellipsis whitespace-nowrap">
                                {label}
                            </span>
                        ) : (
                            label
                        )}
                    </>
                ) : null
            }
            extra={extra ? <div className="ml-1.5">{extra}</div> : null}
        >
            {children}
        </NoColonFormItem>
    )
}

export default FormItem
